import React from "react"

class SidebarNotifications extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
          }

    }
    componentWillMount(){
    }

    render(){

    return(
        <div className={"sidebar-notifications " + this.props.app.state.status_sb_notifications}>
                <div className="head-sidebar">
                    <div onClick={this.props.handleStatusNotifications.bind(this)} className="arrow-press">
                        <span className="arrow"></span>
                    </div>
                    <div className="header-title">NOTIFICATIONS</div>
                </div>
        </div>
    )}
}

export default SidebarNotifications


// WEBPACK FOOTER //
// ./src/Setup/components/SidebarNotifications.js